import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useUpdateForm = () => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.UPDATE_FORM],
    (data) => ApiService.updateForm(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_SAVED_FORM);
        toast.success('Form updated successfully')
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useUpdateForm